module.exports = __webpack_public_path__ + "static/img/8.5c3fc97.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/8.png
// module id = p240
// module chunks = 7